import { TActions } from '../../../../AppModulesWrapper';
import { IPromotionState } from './types';
import { defaultState } from './defaultState';
import {
  CHANGE_IS_SERVICES_ENABLED,
  CHANGE_PROMOTION_SERVICE,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PUBLISH_TERMS_SERVICE,
  SET_IS_SERVICES_ENABLED,
  SET_PROMOTION_TYPE_CHANGE_REASON,
} from '../../../actions/publishTerms';
import { CHANGE_AUCTION_BET, CHANGE_AUCTION_BET_STEPS } from '../../../actions/auction';
import {
  deprecated_mergePublishTerms,
  selectDuration,
  selectService,
  unselectDuration,
  unselectServices,
} from './utils';
import { LOAD_BET_POSITION_SUCCESS } from '../../../actions/betPosition';
import { RESET_STATE } from '../../../actions/resetState';
import { SET_TERMS_DURATION } from '../../../actions/termsDurations';

export const promotion = (state: IPromotionState = defaultState, action: TActions) => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      return deprecated_mergePublishTerms(state, action.payload);
    }
    case CHANGE_IS_SERVICES_ENABLED:
    case SET_IS_SERVICES_ENABLED: {
      return {
        ...state,
        toggle: {
          ...state.toggle,
          checked: action.payload,
        },
        duration: action.payload
          ? selectDuration(state.duration, state.duration.defaultDuration)
          : unselectDuration(state.duration),
        services: action.payload ? selectService(state.services) : unselectServices(state.services),
      };
    }
    case CHANGE_PROMOTION_SERVICE: {
      return {
        ...state,
        toggle: {
          ...state.toggle,
          checked: true,
        },
        services: state.services.map(service => ({
          ...service,
          selected: service.type === action.payload,
        })),
      };
    }
    case SELECT_PUBLISH_TERMS_SERVICE: {
      return {
        ...state,
        toggle: {
          ...state.toggle,
          checked: true,
        },
        duration: selectDuration(state.duration, state.duration.defaultDuration),
        services: state.services.map(service => ({
          ...service,
          selected: service.type === action.payload,
        })),
        isChangedByUser: true,
      };
    }
    case SET_PROMOTION_TYPE_CHANGE_REASON: {
      return {
        ...state,
        banner: {
          ...state.banner,
          promotionTypeChangeReason: action.payload,
        },
      };
    }
    case CHANGE_AUCTION_BET_STEPS: {
      return {
        ...state,
        auctionBet: {
          ...state.auctionBet,
          nextBets: action.payload.nextBets,
          previousBets: action.payload.previousBets,
        },
      };
    }
    case CHANGE_AUCTION_BET: {
      return {
        ...state,
        auctionBet: {
          ...state.auctionBet,
          value: action.payload.bet,
        },
        isChangedByUser: state.isChangedByUser || action.payload.changedByUser,
      };
    }
    case LOAD_BET_POSITION_SUCCESS: {
      return {
        ...state,
        competitors: action.payload.competitors,
      };
    }
    case SET_TERMS_DURATION: {
      return {
        ...state,
        duration: selectDuration(state.duration, action.payload),
      };
    }
    case RESET_STATE:
      return {
        ...defaultState,
        isChangedByUser: false,
      };
    default: {
      return state;
    }
  }
};
